<template>
  <div class="chat-body">

    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span class="card-title">项目概况</span>
        <el-radio-group v-model="projectSelectValue" size="medium" class="projectSelecter">
          <el-radio-button v-for="(item, index) in projectSelecter" :key="index" :label="item.value" >{{ item.label }}</el-radio-button>
        </el-radio-group>
      </div>
      <div class="card-body" v-loading="firstLoading">
        <div class="project-list">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <div class="project-item orange">
                  <div class="number">{{projectOverview.project_number}}</div>
                  <div class="label">项目数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <div class="project-item blue">
                  <div class="number">{{ projectOverview.room_number }}</div>
                  <div class="label">群数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <div class="project-item green">
                  <div class="number">{{ projectOverview.chat_member_number }}</div>
                  <div class="label">发言人数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <div class="project-item red">
                  <div class="number">{{ projectOverview.total_member_number }}</div>
                  <div class="label">累计人数</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>

    <el-card class="box-card" shadow="never" style="margin-top: 15px;">
      <div slot="header" class="clearfix">
        <span class="card-title">成员概况</span>
      </div>
      <div class="card-body" v-loading="secondLoading">

        <div class="project-list">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <div class="project-item red">
                  <div class="number">{{ memberOverview.active_number }}</div>
                  <div class="label">发言人数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <div class="project-item gray">
                  <div class="number">{{ memberOverview.silent_number }}</div>
                  <div class="label">潜水人数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <div class="project-item green">
                  <div class="number">{{ memberOverview.total_number }}</div>
                  <div class="label">累计人数</div>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <div class="project-item orange">
                  <div class="number">{{ memberOverview.active_ratio }}%</div>
                  <div class="label">活跃用户率</div>
                </div>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="grid-content bg-purple">
                <div class="project-item green">
                  <div class="number">{{ memberOverview.chat_times }}</div>
                  <div class="label">发言次数</div>
                </div>
              </div>
            </el-col>
            <!-- <el-col :span="8">
              <div class="grid-content bg-purple">
                <div class="project-item orange">
                  <div class="number">{{ memberOverview.chat_ratio }}%</div>
                  <div class="label">互动率</div>
                </div>
              </div>
            </el-col> -->
          </el-row>
        </div>


      </div>
    </el-card>

  </div>
</template>

<script>

export default {
  name: "ConversationOverview",
  data () {
    return {
      projectSelectValue: "day",
      projectSelecter: [
        {label: "日", value: "day"},
        {label: "周", value: "week"},
        {label: "月", value: "month"},
        {label: "年", value: "year"},
      ],
      projectOverview: {
        project_number: 0,
        room_number: 0,
        total_member_number: 0,
        chat_member_number: 0
      },
      memberOverview: {
        active_number: 0,
        silent_number: 0,
        active_ratio: 0,
        chat_number: 0,
        chat_times: 0,
        chat_ratio: 0
      },
      firstLoading: false,
      secondLoading: false,
    }
  },
  watch: {
    projectSelectValue() {
      this.getProjectOverview()
    }
  },
  created() {
    this.getProjectOverview()
    this.getMemberOverview()
  },
  methods: {
    getProjectOverview() {
      this.firstLoading = true
      this.$qwhttp.get('overview/project', {params: {type: this.projectSelectValue}}).then( res => {
        if(res.status == 200) {
          this.projectOverview = res.data.data
        }

        this.firstLoading = false
      });
    },
    getMemberOverview() {
      this.secondLoading = true
      this.$qwhttp.get('overview/member').then( res => {
        if(res.status == 200) {
          res.data.data.active_ratio = Math.floor(res.data.data.active_ratio * 100) / 100
          res.data.data.chat_ratio = Math.floor(res.data.data.chat_ratio * 100) / 100
          this.memberOverview = res.data.data
        }
        this.secondLoading = false
      });
    },
    loading() {
      return this.$loading({
        lock: true,
        text: 'Loading',
      });
    }
  }
}
</script>
<style scoped>
  .text2,.el-button--primary {
    color: #FFFFFF;
  }

  .chat-body {
    margin: 15px;
  }

  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 100%;
  }

  .projectSelecter {
    float: right;
  }

  .card-title {
    line-height: 36px;
    font-size: 16px;
  }

  .card-body {
    display: flex;
    justify-content: center;
  }

  .project-list {
    width: 100%;
    max-width: 1200px;
  }

  .project-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    border-radius: 4px;
    padding: 20px;
    margin: 5px 0;
    height: 114px;
    box-sizing: border-box;
    color: #fff;
    font-size: 14px;
    text-align: center;

  }

  .project-item .number {
    line-height: 30px;
    font-size: 18px;
    font-weight: bold;
  }

  .project-item .label {
    line-height: 30px;
    font-size: 18px;
    font-weight: bold;
  }

  .project-item.orange {
    background: #E6A23C
  }
  .project-item.blue {
    background: #409EFF
  }
  .project-item.red {
    background: #F56C6C
  }
  .project-item.green {
    background: #67C23A
  }
  .project-item.gray {
    background: #909399
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Conversation/Overview.vue